import { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

interface OptroManagedFieldProps {
  locked: boolean;
  // What the tooltip tells the user to go update in Optro, e.g. "the control".
  // Defaults to the entity-neutral "it".
  entityLabel?: string;
  children: ReactNode;
}

// Wraps a details field that is read-only because its record is linked to
// Optro: hovering the field explains why it can't be edited and how to refresh
// it. Renders children unwrapped when the record isn't linked. The tooltip
// trigger is a wrapper div because disabled form controls don't reliably emit
// the hover events Radix needs, and it is focusable because the disabled
// control inside isn't: keyboard and screen-reader users reach the explanation
// by tabbing to it.
export function OptroManagedField({
  locked,
  entityLabel = "it",
  children,
}: OptroManagedFieldProps) {
  if (!locked) {
    return children;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div tabIndex={0}>{children}</div>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        This field is managed in Optro and can&apos;t be edited here. Update{" "}
        {entityLabel} in Optro, then use <strong>Resync from Optro</strong> in
        the header menu to pull the latest values.
      </TooltipContent>
    </Tooltip>
  );
}
